import Vue from 'vue'
import Router from 'vue-router'
import wx from "weixin-js-sdk";

/*
import index from '@/components/index'
import msg from '@/components/msg'
import mine from '@/components/user/mine'
import ColumnList from '@/components/column/list'
import ColumnDetail from '@/components/column/detail'
import ColumnAudioText from '@/components/column/audioText'
import ColumnTextList from '@/components/column/textList'
import intention from '@/components/intention'
import UserLogin from '@/components/user/login'
import FmList from '@/components/fm/list'
import FmDetail from '@/components/fm/detail'
import EmotionList from '@/components/emotion/list'
import EmotionDetail from '@/components/emotion/detail'
import EmotionTesting from '@/components/emotion/testing'
import CouponList from '@/components/user/coupon'
import pay from '@/components/pay/pay'
import paySuccess from '@/components/pay/success'
import useCoupon from '@/components/pay/coupon'
import vip from '@/components/vip/vip'
import vertivle from '@/components/user/vertivle'
import management from '@/components/user/orderManagement'
import logout from '@/components/user/logout'
import studySchedule from '@/components/user/studySchedule'
import testReport from '@/components/user/testReport'
import collection from '@/components/user/collection'
import liveList from '@/components/live/list'
import bindPhone from '@/components/user/bindPhone'
import PsyDo from '@/components/emotion/PsyDo' // 测评
import PsyReport from '@/components/emotion/PsyReport' // 测评结果
import audioPlayer from '@/components/audio/audio' // 测评结果
*/

/*
 *
 * 按需加载路由组件
 *
 * */
const index = r => require.ensure([], () => r(require('@/components/index')), 'index') //首页
const indexItem = r => require.ensure([], () => r(require('@/components/indexitem')), 'indexitem') //首页项
const prediction = r => require.ensure([], () => r(require('@/components/prediction')), 'prediction') //小课预告
const search = r => require.ensure([], () => r(require('@/components/search')), 'search') //搜索页1
const searchCon = r => require.ensure([], () => r(require('@/components/searchCon')), 'searchCon') //搜索页1
const msg = r => require.ensure([], () => r(require('@/components/msg')), 'msg') //信息
const mine = r => require.ensure([], () => r(require('@/components/user/mine')), 'user_mine') //我的
const ColumnList = r => require.ensure([], () => r(require('@/components/column/list')), 'column_list') //专栏列表
const ColumnDetail = r => require.ensure([], () => r(require('@/components/column/detail')), 'column_detail') //专栏详情
const ColumnAudioText = r => require.ensure([], () => r(require('@/components/column/audioText')), 'column_audioText') //专栏图文详情
const ColumnTextList = r => require.ensure([], () => r(require('@/components/column/textList')), 'column_textList') //专栏图文列表
const intention = r => require.ensure([], () => r(require('@/components/intention')), 'intention') //意向单
const UserLogin = r => require.ensure([], () => r(require('@/components/user/login')), 'user_login') //登录
const FmList = r => require.ensure([], () => r(require('@/components/fm/list')), 'fm_list') //fm列表
const FmDetail = r => require.ensure([], () => r(require('@/components/fm/detail')), 'fm_detial') //fm详情
const EmotionList = r => require.ensure([], () => r(require('@/components/emotion/list')), 'emotion_list') //测试列表
const EmotionDetail = r => require.ensure([], () => r(require('@/components/emotion/detail')), 'emotion_detail') //测试详情
const EmotionTesting = r => require.ensure([], () => r(require('@/components/emotion/testing')), 'emotion_testing') //答题
const CouponList = r => require.ensure([], () => r(require('@/components/user/coupon')), 'user_coupon') //优惠券列表
// const pay = r => require.ensure([], () => r(require('@/components/pay/pay')),'pay')//支付
// const paySuccess = r => require.ensure([], () => r(require('@/components/pay/success')),'pay_success')//支付成功
// const useCoupon = r => require.ensure([], () => r(require('@/components/pay/coupon')),'useCoupon')//用户优惠券
const pay = r => require.ensure([], () => r(require('@/components/live/pay')), 'pay') //支付
const paySuccess = r => require.ensure([], () => r(require('@/components/live/success')), 'pay_success') //支付成功
const useCoupon = r => require.ensure([], () => r(require('@/components/live/coupon')), 'useCoupon') //用户优惠券
const vip = r => require.ensure([], () => r(require('@/components/vip/vip')), 'vip') //vip
const yxd = r => require.ensure([], () => r(require('@/components/user/yxd')), 'yxd') //意向单
const vertivle = r => require.ensure([], () => r(require('@/components/user/vertivle')), 'vertivle') //
const management = r => require.ensure([], () => r(require('@/components/user/orderManagement')), 'management') //订单
const logout = r => require.ensure([], () => r(require('@/components/user/logout')), 'logout') //登出
const studySchedule = r => require.ensure([], () => r(require('@/components/user/studySchedule')), 'studySchedule') //学习进度
const testReport = r => require.ensure([], () => r(require('@/components/user/testReport')), 'testReport') //测试报告
const collection = r => require.ensure([], () => r(require('@/components/user/collection')), 'collection') //收藏列表
const liveList = r => require.ensure([], () => r(require('@/components/live/list')), 'liveList') //直播列表
const bindPhone = r => require.ensure([], () => r(require('@/components/user/bindPhone')), 'bindPhone') //绑定手机
const bindEmail = r => require.ensure([], () => r(require('@/components/user/bindEmail')), 'bindEmail') //绑定手机
const changePW = r => require.ensure([], () => r(require('@/components/user/changePW')), 'changePW') //绑定手机
const PsyDo = r => require.ensure([], () => r(require('@/components/emotion/PsyDo')), 'PsyDo') //做测试题
const PsyReport = r => require.ensure([], () => r(require('@/components/emotion/PsyReport')), 'PsyDo') //测试报告
const masterCourseList = r => require.ensure([], () => r(require('@/components/masterCourse/list')), 'masterCourse_list') //大师课程列表
const masterCourseDetail = r => require.ensure([], () => r(require('@/components/masterCourse/detail')), 'masterCourse_detial') //大师课程详情
const articleList = r => require.ensure([], () => r(require('@/components/article/list')), 'article_list') //大师课程列表
const articleDetail = r => require.ensure([], () => r(require('@/components/article/detail')), 'article_detial') //大师课程详情

// 情感大学
const collegeList = r => require.ensure([], () => r(require('@/components/college/list')), 'college_list')
const collegeDetail = r => require.ensure([], () => r(require('@/components/college/detail')), 'college_detail')
const collegeSchedule = r => require.ensure([], () => r(require('@/components/college/schedule')), 'college_schedule')

Vue.use(Router);

// export default new Router({
var router = new Router({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'index',
        meta: {
            keepAlive: true
        },
        component: index
    },
        {
            path: '/index',
            name: 'index',
            meta: {
                keepAlive: true
            },
            component: index
        },
        {
            path: '/indexitem',
            name: 'indexItem',
            meta: {
                keepAlive: true
            },
            component: indexItem
        },
        {
            path: '/user/yxd',
            name: 'yxd',
            meta: {
                keepAlive: true
            },
            component: yxd
        },
        {
            path: '/prediction',
            name: 'prediction',
            meta: {
                keepAlive: true
            },
            component: prediction
        },
        {
            path: '/search',
            name: 'search',
            component: search
        },
        {
            path: '/searchCon',
            name: 'searchCon',
            component: searchCon
        },
        {
            path: '/msg',
            name: 'msg',
            meta: {
                requireAuth: true
            },
            component: msg
        },
        {
            path: '/user/mine',
            name: 'user_mine',
            meta: {
                requireAuth: true
            },
            component: mine
        },
        {
            path: '/intention',
            name: 'intention',
            component: intention
        },
        {
            path: '/user/login',
            name: 'user_login',
            component: UserLogin
        },
        {
            path: '/column/list',
            name: 'column_list',
            component: ColumnList
        },
        {
            path: '/column/detail',
            name: 'column_detail',
            component: ColumnDetail
        },
        {
            path: '/column/audioText',
            name: 'column_audioText',
            component: ColumnAudioText
        },
        {
            path: '/column/textList',
            name: 'column_textList',
            component: ColumnTextList
        },
        {
            path: '/fm/list',
            name: 'fm_list',
            component: FmList
        },
        {
            path: '/fm/detail',
            name: 'fm_detial',
            component: FmDetail
        },
        {
            path: '/emotion/list',
            name: 'emotion_list',
            component: EmotionList
        },
        {
            path: '/emotion/detail',
            name: 'emotion_detail',
            component: EmotionDetail
        },
        {
            path: '/emotion/testing',
            name: 'emotion_testing',
            component: EmotionTesting
        },
        {
            name: 'PsyDo',
            path: '/emotion/psy-do/:psyId',
            component: PsyDo
        },
        {
            name: 'PsyReport',
            path: '/emotion/psy-report/:psyId',
            component: PsyReport
        },
        {
            path: '/user/coupon',
            name: 'user_coupon',
            meta: {
                requireAuth: true
            },
            component: CouponList
        },
        // {
        //     path: '/pay/pay',
        //     name: 'pay',
        //     meta: {
        //         requireAuth: true
        //     },
        //     component: pay
        // },
        // {
        //     path: '/pay/success',
        //     name: 'pay_success',
        //     meta: {
        //         requireAuth: true
        //     },
        //     component: paySuccess
        // },
        // {
        //     path: '/pay/coupon',
        //     name: 'useCoupon',
        //     component: useCoupon
        // },
        {
            path: '/live/pay',
            name: 'pay',
            meta: {
                requireAuth: true
            },
            component: pay
        },
        {
            path: '/live/success',
            name: 'pay_success',
            meta: {
                requireAuth: true
            },
            component: paySuccess
        },
        {
            path: '/live/coupon',
            name: 'useCoupon',
            component: useCoupon
        },
        {
            path: '/user/vip',
            name: 'vip',
            component: vip
        },
        {
            path: '/user/vertivle',
            name: 'vertivle',
            meta: {
                requireAuth: true
            },
            component: vertivle
        },
        {
            path: '/user/orderManagement',
            name: 'management',
            meta: {
                requireAuth: true
            },
            component: management
        },
        {
            path: '/user/logout',
            name: 'logout',
            component: logout
        },
        {
            path: '/user/studySchedule',
            name: 'studySchedule',
            component: studySchedule
        },
        {
            path: '/user/testReport',
            name: 'testReport',
            component: testReport
        },
        {
            path: '/user/collection',
            name: 'collection',
            component: collection
        },
        {
            path: '/live/list',
            name: 'liveList',
            component: liveList
        },
        // 新浪微博登录
        {
            path: '/user/bindPhone',
            name: 'bindPhone',
            component: bindPhone
        },
        {
            path: '/user/changePW',
            name: 'changePW',
            component: changePW
        },
        {
            path: '/user/bindEmail',
            name: 'bindEmail',
            component: bindEmail
        },
        {
            path: '/masterCourseList/list',
            name: 'masterCourseList_list',
            component: masterCourseList
        },
        {
            path: '/masterCourse/detail',
            name: 'masterCourseDetail_detial',
            component: masterCourseDetail
        },
        {
            path: '/articleList/list',
            name: 'articleList_list',
            component: articleList
        },
        {
            path: '/article/detail',
            name: 'article_detial',
            component: articleDetail
        },
        {
            path: '/college/list',
            name: 'college',
            component: collegeList
        },
        {
            path: '/college/detail',
            name: 'college_detial',
            component: collegeDetail
        },
        {
            path: '/college/schedule',
            name: 'college_schedule',
            component: collegeSchedule
        }


    ]
})

//登录拦截器
router.beforeEach((to, from, next) => {
    if (to.matched.some(res => res.meta.requireAuth)) {

        // alert("token:"+getCookie('token'));

        //是否需要登录
        if (getCookie('token')) {
            //是否已经登录
            next()
        } else {
            // console.log('routerlogin');
            // next({
            //     path: '/user/login',
            //     //query: {redirect: to.fullPath}
            // })
            goAppLogin();
        }
    } else {
        next()
    }
    //console.log(to.fullPath);
})

router.afterEach(function (to) {
    if (!sessionStorage.getItem('initLink')) {
        sessionStorage.setItem('initLink', document.URL)
    }
})

function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return (arr[2]);
    else
        return '';
}

function goAppLogin() {
    saveBackPage();
    var para_url = '/pages/loginFive/loginFive';
    wx.miniProgram.navigateTo({url: para_url});
}

function saveBackPage() {
    setCookie('backPage', window.location.href, 1000 * 60 * 60 * 24 * 2);
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js